export default (theme) => ({
  statusLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  greenRound: {
    width: 15,
    height: 15,
    backgroundColor: 'green',
    marginRight: 5,
    borderRadius: '50%',
    opacity: 0.8,
    [theme.breakpoints.down('sm')]: {
      width: 10,
      height: 10,
      marginRight: 3,
    },
  },
  redRound: {
    backgroundColor: 'red',
  },
  statusText: {
    fontWeight: 'bold',
    lineHeight: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
});
